import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email("Valid email address is required"),
  password: z
    .string()
    .min(8, "The password field must be at least 8 characters long."),
});

export const OnboardingSchema = z
  .object({
    password: z
      .string()
      .min(8, "The password is too short.")
      .regex(
        /[A-Z]/,
        "The password must contain at least one uppercase letter."
      )
      .regex(/[0-9]/, "The password must contain at least one number.")
      .regex(
        /[a-z]/,
        "The password must contain at least one lowercase letter."
      ),
    confirm_password: z
      .string()
      .min(8, "The confirmation password is too short."),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: "Password and confirm password do not match.",
    path: ["confirm_password"], // Points to the field with the error
  });

export type loginType = z.infer<typeof loginSchema>;
export type OnboardingType = z.infer<typeof OnboardingSchema>;
